import {lazy} from 'react';

import type {RouteConfig} from '../types';

import {Loadable} from '../components/Loadable';
import {contentRoutesPath} from './path';

const ContentListPage = Loadable(
  lazy(() =>
    import(
      '@src/v2/pages/ContentList' /* webpackChunkName: "content-list-page" */
    ).then(module => ({default: module.ContentListPage})),
  ),
);
const ContentPage = Loadable(
  lazy(() =>
    import('@src/v2/pages/Content' /* webpackChunkName: "content-page" */).then(
      module => ({
        default: module.ContentPage,
      }),
    ),
  ),
);

export const contentRoutes = [
  {
    element: <ContentListPage />,
    path: contentRoutesPath.$path(),
  },
  {
    element: <ContentPage />,
    path: contentRoutesPath.article.$path(),
  },
] satisfies RouteConfig[];
